import 'jquery-match-height/dist/jquery.matchHeight.js';
//const widthSize = window.innerWidth;
export default class MatchHeight {

  constructor() {

    $(function() {
      $('.matchHeight li .ttl').matchHeight();
      $('.matchHeight li .text').matchHeight();
    });

    $(function(){
      //文字制限
      let $setStringElm = $(".matchHeight li .text");
      let $cutString = '100';
      let afterTxt = '・・・';

      $setStringElm.each(function(){
        var textLength = $(this).text().length;
        var textTrim = $(this).text().substr(0,($cutString))

        if($cutString < textLength) {
            $(this).html(textTrim + afterTxt).css({visibility:'visible'});
        } else if($cutString >= textLength) {
            $(this).css({visibility:'visible'});
        }
      });
    });



  }





}

